import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { UserProvider } from "./contexts/UserContext";
import i18n from "./i18n";
import StaticPublicPage, { StaticPageBootstrap } from "./components/StaticPublicPage";

const rootElement = document.getElementById("root") as HTMLElement;
const staticPageBootstrap = document.getElementById("static-page-bootstrap");
const bootstrap = staticPageBootstrap?.textContent
  ? JSON.parse(staticPageBootstrap.textContent) as Omit<StaticPageBootstrap, "translations">
  : null;
const currentPath = window.location.pathname.replace(/\/+$/, "") || "/";
const staticPath = bootstrap
  ? `/${bootstrap.language}${bootstrap.routePath === "/" ? "" : bootstrap.routePath}`
  : null;
const matchesStaticPage = staticPath === currentPath ||
  (staticPath === "/en" && currentPath === "/");

if (bootstrap && matchesStaticPage) {
  i18n.changeLanguage(bootstrap.language).then(() => {
    const translations = i18n.getResourceBundle(bootstrap.language, "translation");
    if (!translations) {
      return;
    }
    window.autovidStaticHydrating = true;
    ReactDOM.hydrateRoot(
      rootElement,
      <BrowserRouter>
        <StaticPublicPage {...bootstrap} translations={translations} />
      </BrowserRouter>
    );
  });
} else {
  rootElement.replaceChildren();
  document.documentElement.classList.remove("autovid-spa-route");
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <UserProvider>
      <App />
    </UserProvider>
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
